import { render, staticRenderFns } from "./PUCMedia.vue?vue&type=template&id=7d1b48b6&scoped=true&functional=true&"
import script from "./PUCMedia.vue?vue&type=script&lang=js&"
export * from "./PUCMedia.vue?vue&type=script&lang=js&"
import style0 from "./PUCMedia.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PUCMedia.vue?vue&type=style&index=1&id=7d1b48b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7d1b48b6",
  null
  
)

export default component.exports